import { PaymentTokenRequest, PaymentTokenResponse } from '@/types/virtual-terminal'
import { postWithAuth } from '../base'

export const fetchPaymentToken = (requestBody: PaymentTokenRequest) => postWithAuth<PaymentTokenResponse>('/oppapi/v1/virtual-terminal/token', requestBody)
